








































import { Component, Vue } from 'vue-property-decorator'
import { getCHageRecordList } from '_user/api'
import RecordSkeleton from './components/RecordSkeleton.vue'
import moment from 'moment'
import { LoyoutModule } from '@/store/modules/layout'

@Component({
  components: {
    RecordSkeleton
  }
})
export default class extends Vue {
  list: any = []
  loading = false
  finished = false
  showSke = true
  pageInfo = {
    currPage: 0,
    pageSize: 20,
    total: 0,
    totalPage: 0
  }
  getDate(t: number) {
    return moment(t * 1000).format('YYYY-MM-DD HH:mm:ss')
  }
  async getRecordList() {
    const params = {
      page: this.pageInfo.currPage + 1,
      limit: this.pageInfo.pageSize
    }

    const { data } = await getCHageRecordList(params)
    this.loading = false
    this.showSke = false
    this.pageInfo = data.pageInfo
    this.list.push(...data.list)

    if (this.list.length == this.pageInfo.total) {
      this.finished = true
    }
  }
  recordName(item: any) {
    if (item.recordType == 1) {
      return this.$t('充值') + item.amount + this.$t('金币')
    } else if (item.recordType == 2) {
      return this.$t('兑换') + item.amount + this.$t('银豆')
    } else if (item.recordType == 3) {
      return this.$t('兑换') + item.amount + this.$t('金豆')
    }
  }
  mounted() {
    const title: any = this.$t('交易明细')
    LoyoutModule.setTitle(title)
    this.getRecordList()
  }
}
